import type { App } from "vue";
import VueDomPurifyHtml from "vue-dompurify-html";

export default {
  install(app: App) {
    app.use(VueDomPurifyHtml, {
      default: {
        ALLOWED_TAGS: [
          "iframe",
          "img",
          "p",
          "div",
          "span",
          "br",
          "strong",
          "em",
          "u",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "ul",
          "ol",
          "li",
          "table",
          "tr",
          "td",
          "th",
          "thead",
          "tbody",
        ],
        ALLOWED_ATTR: [
          "src",
          "width",
          "height",
          "frameborder",
          "allowfullscreen",
          "style",
          "class",
          "id",
          "title",
          "alt",
          "href",
          "target",
          "rowspan",
          "colspan",
        ],
        ADD_ATTR: ["sandbox"],
        FORBID_TAGS: ["script", "object", "embed", "form", "input", "button", "select", "textarea"],
        FORBID_ATTR: ["onclick", "onload", "onerror", "onmouseover", "onfocus", "onblur"],
        SANITIZE_DOM: (node: HTMLElement) => {
          if (node.nodeName !== "IFRAME") return;

          const src = node.getAttribute("src");
          if (!src) return;

          const allowedDomains = [
            "www.youtube-nocookie.com",
            "youtube-nocookie.com",
            "www.vimeo.com",
            "vimeo.com",
          ];

          try {
            const url = new URL(src);
            const isAllowed = allowedDomains.some(
              (domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)
            );

            if (!isAllowed) {
              node.removeAttribute("src");
              node.setAttribute("data-blocked", "true");
              node.innerHTML = "보안상 차단된 iframe입니다.";
            } else {
              node.setAttribute(
                "sandbox",
                "allow-same-origin allow-scripts allow-popups allow-forms"
              );
              node.setAttribute("referrerpolicy", "no-referrer");
              node.setAttribute("loading", "lazy");
            }
          } catch {
            node.removeAttribute("src");
          }
        },
      },
    });
  },
};
